export default "__VITE_ASSET__B_852Hkb__"